module.exports = __webpack_public_path__ + "img/calendar-icon.png";